import { useContext } from 'react';
import { SavedFiltersContext } from '../contexts/SavedFiltersContext';

export function useSavedFiltersContext() {
    const context = useContext(SavedFiltersContext);

    if (!context) {
        throw new Error('useSavedFiltersContext must be used within SavedFiltersProvider');
    }

    return context;
}
